import React from 'react';
import { createRoot } from 'react-dom/client';
// Self-hosted Noto Color Emoji (COLRv1 woff2, unicode-range subset). Windows'
// system emoji font (Segoe UI Emoji) ships NO country-flag glyphs, so flags
// like 🇩🇴 fall back to their two regional-indicator letters ("DO") in
// Chrome/Edge/Firefox on Windows. Appending "Noto Color Emoji" to the font
// stacks (theme.js) makes those glyphs render as real flags. The font is split
// by unicode-range, so the 686KB flags chunk only downloads when a flag is
// actually shown. Self-hosted (not a CDN) per our CSP/privacy posture.
import '@infolektuell/noto-color-emoji';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux'
import store from './redux/store'
import { BUILD } from './config'

// Operator-facing build banner. Logs the version + git short SHA + build time on
// boot (the standard "which commit is live?" signal lives here + /api/health,
// NOT in the user-facing About dialog). window.__BUILD__ exposes it for quick
// inspection from the console.
window.__BUILD__ = BUILD;
console.info(
  `%cChatCove%c v${BUILD.version} · ${BUILD.commit} · built ${BUILD.builtAt || 'dev'}`,
  'font-weight:bold;color:#00d9ff',
  'color:inherit'
);

const root = createRoot(document.getElementById('chat'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
